<template>
  <div id="continueEdu" class="rdiv">
    <Header @to-login="toLoginPage" :user="user" :token="token" :txt="headerTxt" @to-logout="toLogout" @to-reg="toReg" @to-record="toRecord"></Header>
    <div class="zhicheng_menu">
      <div class="wrap w1200">
        <div class="col_1 menu_r">
          <router-link :to="'/continueEdu/home'" active-class="focus">首页</router-link>
          <router-link :to="'/continueEdu/courseList'" active-class="focus" :class="{'focus': subIsActive('/continueEdu/courseList')}">课程学习</router-link>
          <router-link :to="'/continueEdu/planList'" active-class="focus" :class="{'focus': subIsActive('/continueEdu/planList')}">培训计划</router-link>
          <router-link :to="'/continueEdu/enrollList'" active-class="focus" :class="{'focus': subIsActive('/continueEdu/enrollList')}">报名信息</router-link>
          <router-link :to="'/continueEdu/trainList'" active-class="focus" :class="{'focus': subIsActive('/continueEdu/trainList')}">培训信息</router-link>
          <router-link :to="'/continueEdu/newsList'" active-class="focus" :class="{'focus': subIsActive('/continueEdu/newsList')}">新闻咨询</router-link>
          <router-link :to="'/continueEdu/taskList'" active-class="focus" :class="{'focus': subIsActive('/continueEdu/taskList')}" v-if="token">任务中心</router-link>
        </div>
        <!--div class="col_2 w200">
          <input name="" type="button" class="search_bt" /><input name="" class="search_put" type="text" placeholder="输入关键字搜索" />
        </div-->
      </div>
    </div>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>
<script>
  import Header from '@/components/continueEdu/header/header.vue'
  import Footer from '@/components/byl/footer/footer.vue'
  import utils from '@/utils'
  import { mapState, mapActions } from 'vuex'

export default {
  components: { Header, Footer },
  data () {
    return {
      headerTxt: '管理企业',
      currentActivePath: ''
    }
  },
  computed: {
    ...mapState('auth', ['user', 'token'])
  },
  created () {
  },
  mounted () {
    if (this.$route.meta.navClass) { // 应付刷新
      this.currentActivePath = this.$route.meta.navClass
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.currentActivePath = val.meta.navClass
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    ...mapActions('auth', {
      logout: 'logout'
    }),
    subIsActive (input) {
      return this.currentActivePath == input
    },
    toLoginPage () {
      var domain = utils.getQueryString('domain')
      var back_route = window.location.hash.split('?')[0]
      window.location.href = window.location.origin + '/#/byl/login?h=' + back_route + '&domain=' + domain
    },
    toLogout () {
      if (this.user) {
        this.logout()
      }
    },
    toReg () {
      var domain = utils.getQueryString('domain')
      var back_route = window.location.hash.split('?')[0]
      window.location.href = window.location.origin + '/#/byl/orgreg?h=' + back_route + '&domain=' + domain
    },
    toRecord () {
      this.$router.push('/continueEdu/org')
    }
  }
}
</script>
<style lang="scss">
  #continueEdu .study_detail_top { margin-top: 0; }
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/index.vue